import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePreloadPlayerStore = defineStore('preloadPlayerStore', () => {
    const isShakaPlayerLoadingStarted = ref(false)

    async function preloadPlayer() {
        if (isShakaPlayerLoadingStarted.value) {
            return
        }

        isShakaPlayerLoadingStarted.value = true

        if (document.createElement('video').canPlayType('application/vnd.apple.mpegurl') === '') {
            await import('shaka-player/dist/shaka-player.dash.js')
        }
    }

    return {
        preloadPlayer,
    }
})
